/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.CostItemMappingRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
